import { render } from "./BootstrapCollapse.vue?vue&type=template&id=9dc8cbb6&scoped=true"
import script from "./BootstrapCollapse.vue?vue&type=script&lang=js"
export * from "./BootstrapCollapse.vue?vue&type=script&lang=js"

import "./BootstrapCollapse.vue?vue&type=style&index=0&id=9dc8cbb6&scoped=true&lang=css"

import exportComponent from "../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dc8cbb6"]])

export default __exports__